import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

class Table extends React.Component {

	render () {
		if(this.props.data == null) {
			return ( null );
		} else {
			return (
				<div className="col-md-12">
					<div className="card">
						<div className="title-row align-items-center">
							<div className="card-title tab">
								<h5 className="pl-3 pr-3">{this.props.data.table_title??null}</h5>
							</div>
							{ this.props.addButton &&
							<div onClick={this.props.addButton} className="card-title card-title-end tab ml-auto border-left border-right-0 justify-content-center addbutton"><i className="fas fa-plus pl-3 pr-3"></i></div>
							}
						</div>
						<div className="card-body card-body-table pt-0 pb-0">
						<table className="table mb-0">
							<thead>
								<tr>
								{this.props.data.table_title_row.cells.map((value,index) => {
										return <th scope="col" className={this.props.condensed?"pb-2 pt-2":""} key={index}>{value}</th>
									})}
								</tr>
							</thead>
							<tbody>
							{this.props.data.table_body_rows.map((value, index) => {
								return (
								<tr key={index}>
									{value.map((value,index) => {
										return <td key={index} dangerouslySetInnerHTML={{ __html: value }}></td>
									})}
								</tr>
								)
							})}

							{this.props.data.table_totals != null &&
								<tr className="table-total">
									{this.props.data.table_totals.cells.map((value,index) => {
										return <td key={index}>{value}</td>
									})}
								</tr>
								}

							</tbody>
						</table>
						</div>
					</div>
				</div>
			);
		}
	}
}

export default Table;
// function mapStateToProps(state) {
// 	return { state:state }
// }

// export default connect(mapStateToProps)(FeedbackList)